import cn from "../../../utils/cn";
import PropTypes from 'prop-types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Spinner = _ref => {
  let {
    className = '',
    scale = 1,
    style = {},
    text = '',
    textStyle = {},
    center = false
  } = _ref;
  const centerStyles = center ? ['flex', 'justify-center', 'h-full', 'items-center'] : [];
  return /*#__PURE__*/_jsxs("div", {
    "aria-label": "Loading",
    "aria-live": "polite",
    className: cn('spinner-container', centerStyles, className),
    style: {
      transform: "scale(".concat(scale, ")")
    },
    role: "status",
    children: [/*#__PURE__*/_jsx("svg", {
      className: "spinner",
      style: style,
      width: "66px",
      height: "66px",
      viewBox: "0 0 66 66",
      children: /*#__PURE__*/_jsx("circle", {
        className: "path",
        fill: "none",
        strokeWidth: "6px",
        strokeLinecap: "round",
        cx: "33",
        cy: "33",
        r: "30"
      })
    }), text && /*#__PURE__*/_jsx("h4", {
      style: textStyle,
      children: text
    })]
  });
};
Spinner.propTypes = {
  className: PropTypes.string,
  scale: PropTypes.number,
  style: PropTypes.object,
  text: PropTypes.string,
  textStyle: PropTypes.object,
  center: PropTypes.bool
};
export default Spinner;
//# sourceMappingURL=Spinner.js.map